import { createRequest } from './createRequest'

export const resetPassword = createRequest({ path: '/reset-password' })
